import React, { useState } from "react";
import { Check, Ban, MessageSquare, Wrench } from "lucide-react";
import { Input } from "@/components/ui/input";
import { SERVICE, labelOf } from "@/lib/inspection";

export const MechanicService = ({ vtype, items, lang, t, locked, onChange }) => {
  const [noteFor, setNoteFor] = useState(null);
  const rows = SERVICE[vtype] || SERVICE.car;
  const done = rows.filter(([k]) => items[k]?.status === "done").length;
  const na = rows.filter(([k]) => items[k]?.status === "na").length;
  const pct = Math.round(((done + na) / rows.length) * 100);

  const toggle = (key, label, status) => {
    if (locked) return;
    const next = { ...items };
    if (next[key]?.status === status) delete next[key]; else next[key] = { ...(next[key] || {}), status, label };
    onChange(next);
  };
  const setNote = (key, label, note) => onChange({ ...items, [key]: { ...(items[key] || { status: "done" }), label, note } });

  return (
    <div className="rounded-2xl border border-border bg-gradient-to-br from-slate-950 to-slate-900 text-white p-4 sm:p-5 space-y-4" data-testid="mechanic-service">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3">
          <span className="h-10 w-10 rounded-xl bg-primary grid place-items-center"><Wrench className="h-5 w-5" /></span>
          <div>
            <div className="font-semibold text-base md:text-lg">{t("mech_service_title")}</div>
            <div className="text-xs text-slate-400">{t("mech_service_hint")}</div>
          </div>
        </div>
        <div className="text-right">
          <div className="font-mono text-2xl font-bold tabular-nums" data-testid="mechanic-service-progress">{done + na}<span className="text-slate-500 text-base">/{rows.length}</span></div>
          <div className="h-1.5 w-28 rounded-full bg-slate-800 overflow-hidden"><div className="h-full bg-primary transition-[width] duration-300" style={{ width: `${pct}%` }} /></div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
        {rows.map(([key, lbl], i) => {
          const label = labelOf(lbl, lang); const cur = items[key];
          const isDone = cur?.status === "done"; const isNa = cur?.status === "na";
          return (
            <div key={key} className={`rounded-xl border px-3 py-2 transition-colors ${isDone ? "border-emerald-500/50 bg-emerald-500/10" : isNa ? "border-slate-700 bg-slate-800/60 opacity-70" : "border-slate-800 bg-slate-900/60"}`} data-testid={`mechanic-svc-row-${key}`}>
              <div className="flex items-center gap-2">
                <span className="font-mono text-[11px] text-slate-500 w-5">{String(i + 1).padStart(2, "0")}</span>
                <span className={`text-sm flex-1 ${isDone ? "font-medium" : ""} ${isNa ? "line-through text-slate-400" : ""}`}>{label}</span>
                <button disabled={locked} onClick={() => toggle(key, label, "done")} title={t("mech_done")} className={`h-11 w-11 rounded-lg border grid place-items-center transition-colors ${isDone ? "bg-emerald-500 border-emerald-500" : "border-slate-700 text-slate-400 hover:border-emerald-400"}`} data-testid={`mechanic-svc-${key}-done`}><Check className="h-5 w-5" /></button>
                <button disabled={locked} onClick={() => toggle(key, label, "na")} title={t("mech_na")} className={`h-11 w-11 rounded-lg border grid place-items-center transition-colors ${isNa ? "bg-slate-600 border-slate-600" : "border-slate-700 text-slate-400 hover:border-slate-400"}`} data-testid={`mechanic-svc-${key}-na`}><Ban className="h-4 w-4" /></button>
                <button disabled={locked} onClick={() => setNoteFor(noteFor === key ? null : key)} className={`h-11 w-11 rounded-lg border grid place-items-center ${cur?.note ? "border-primary text-primary" : "border-slate-700 text-slate-400"}`} data-testid={`mechanic-svc-${key}-note`}><MessageSquare className="h-4 w-4" /></button>
              </div>
              {(noteFor === key || cur?.note) && (
                <Input value={cur?.note || ""} onChange={(e) => setNote(key, label, e.target.value)} placeholder={t("mech_service_note_ph")} disabled={locked} className="h-10 mt-2 text-sm bg-slate-950 border-slate-700 text-white placeholder:text-slate-500" data-testid={`mechanic-svc-${key}-note-input`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
